import styled from 'styled-components'

const defaultSlideControlsTop = '57.5%'
const defaultSlideControlsLeft = '81%'
const defaultSlideControlsRight = '92.5%'

interface InfoSliderContainerProps {
  controlsTop?: string
  controlsLeft?: string
}

export const InfoSliderContainer = styled.div<InfoSliderContainerProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: 50vw;
  height: 100%;

  div:not(.content, .controls) {
    height: 100%;
  }

  .slick-arrow {
    display: none !important;
  }

  .controls {
    position: absolute;
    width: 100%;
    top: ${props => props.controlsTop || defaultSlideControlsTop};

    & > * {
      position: absolute;
      background: none;
      color: var(--light);
    }
  }

  #btn_prev {
    left: ${props => props.controlsLeft || defaultSlideControlsLeft};
  }

  #btn_next {
    left: ${defaultSlideControlsRight};
  }

  .slick-dots {
    width: fit-content;
    height: fit-content;
    top: calc(${props => props.controlsTop || defaultSlideControlsTop} - 0.3%);
    left: calc(${props => props.controlsLeft || defaultSlideControlsLeft} + 4%);

    button::before {
      font-size: 8px;
      opacity: 0.3;
      color: var(--light);
    }

    .slick-active button::before {
      opacity: 1;
      color: var(--light);
    }
  }

  @media only screen and (max-width: 1023px) {
    //MOBILE

    display: none;
  }

  @media only screen and (max-width: 1600px) {
    //LAPTOPS L

    .controls {
      top: calc(
        ${props => props.controlsTop || defaultSlideControlsTop} + 2.5%
      );
    }

    .slick-dots {
      top: calc(
        ${props => props.controlsTop || defaultSlideControlsTop} + 2.2%
      );
    }
  }

  @media only screen and (max-width: 1400px) {
    //LAPTOPS M

    .controls {
      top: calc(
        ${props => props.controlsTop || defaultSlideControlsTop} + 3.5%
      );
    }

    .slick-dots {
      top: calc(
        ${props => props.controlsTop || defaultSlideControlsTop} + 3.2%
      );
      left: calc(
        ${props => props.controlsLeft || defaultSlideControlsLeft} + 3.1%
      );
    }

    #btn_prev {
      left: calc(
        ${props => props.controlsLeft || defaultSlideControlsLeft} - 1%
      );
    }
  }

  @media only screen and (max-width: 1200px) {
    //LAPTOPS S

    .controls {
      top: calc(
        ${props => props.controlsTop || defaultSlideControlsTop} + 5.5%
      );
    }

    .slick-dots {
      top: calc(
        ${props => props.controlsTop || defaultSlideControlsTop} + 5.2%
      );
      left: calc(
        ${props => props.controlsLeft || defaultSlideControlsLeft} - 2%
      );
    }

    #btn_prev {
      left: calc(
        ${props => props.controlsLeft || defaultSlideControlsLeft} - 7%
      );
    }

    #btn_next {
      left: calc(${defaultSlideControlsRight} - 2%);
    }
  }

  @media only screen and (max-width: 1050px) {
    //TABLET

    .controls {
      top: calc(
        ${props => props.controlsTop || defaultSlideControlsTop} + 3.5%
      );
    }

    .slick-dots {
      top: calc(
        ${props => props.controlsTop || defaultSlideControlsTop} + 3.2%
      );
    }
  }
`
